'use es6';

import Layout from 'DesignData/models/layouts/Layout';
import PortalCopyTypes from 'DesignData/enums/PortalCopyTypes';
/**
 * Wrapper class of Global Group data.
 * Intended for reflection and helper methods.
 */

export default class GlobalGroup extends Layout {
  /**
   * @constructor
   */
  constructor(props) {
    return super(props);
  }

  gePortalCopyType() {
    return PortalCopyTypes.LAYOUT;
  }

}